import { cva } from 'class-variance-authority';

export const cvaCalendarNav = cva([
  'CalendarNavStyles-cvaCalendarNav',
  'fixed bottom-0 left-0 z-20',
  'w-full',
  'bg-cDarkGray rounded-t-[0.8rem] ',
]);

export const cvaCalendarNavInner = cva([
  'CalendarNavStyles-cvaCalendarNav',
  'flex flex-col gap-1.2',
  'p-1.6 pb-3.2',
]);
